import { Controller } from "@hotwired/stimulus"

// Fixe oder dynamische Zeitspanne im Task-Filter: Die Checkbox (toggle)
// schaltet zwischen den Datumsfeldern (fixed, im Bereich range) und den Radios
// (dynamic) um. Gesperrte Felder sendet der Browser nicht, daran erkennt der
// Filter die gewählte Art. Ersetzt den Handler aus admin/tasks.js.erb.
export default class extends Controller {
  static targets = ["toggle", "dynamic", "fixed", "range"]

  connect() {
    this.update()
  }

  update() {
    const fixed = this.toggleTarget.checked
    this.fixedTargets.forEach((input) => { input.disabled = !fixed })
    this.dynamicTargets.forEach((input) => { input.disabled = fixed })
    this.rangeTargets.forEach((element) => { element.hidden = !fixed })
  }
}
